import React from 'react';
import { Card } from 'antd';

interface DashboardCardProps {
  title: string;
  value: string | number;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ title, value }) => {
  return (
    <Card className="w-full m-0 mb-4">
      <div className="text-gray-500 text-base mb-2">{title}</div>
      <div className="text-3xl font-bold text-gray-900">{value}</div>
    </Card>
  );
};

export default DashboardCard;
